import { render, staticRenderFns } from "./CrmEditHistoryEvent.vue?vue&type=template&id=78a3f546&scoped=true"
import script from "./CrmEditHistoryEvent.vue?vue&type=script&lang=ts"
export * from "./CrmEditHistoryEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a3f546",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a3f546')) {
      api.createRecord('78a3f546', component.options)
    } else {
      api.reload('78a3f546', component.options)
    }
    module.hot.accept("./CrmEditHistoryEvent.vue?vue&type=template&id=78a3f546&scoped=true", function () {
      api.rerender('78a3f546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmEditHistoryEvent.vue"
export default component.exports